import React from 'react';
import { SearchableSelect } from '@/shared/ui/custom/searchable-select';
import { Label } from '@/components/ui/label';
import { Client } from '../types';

interface ClientSelectorProps {
  clients: Client[];
  value: string;
  onChange: (value: string) => void;
}

export const ClientSelector: React.FC<ClientSelectorProps> = ({
  clients,
  value,
  onChange,
}) => {
  const clientOptions = React.useMemo(
    () =>
      clients.map((client) => ({
        value: client.id.toString(),
        label: client.name,
      })),
    [clients]
  );

  return (
    <div className="space-y-2">
      <Label htmlFor="client">Client</Label>
      <SearchableSelect
        options={clientOptions}
        value={value}
        onValueChange={onChange}
        placeholder="Select a client"
        searchPlaceholder="Search clients..."
        emptyMessage="No clients with active projects found."
      />
    </div>
  );
};

